module.exports = __webpack_public_path__ + "img/appAsset-brand--nfe.47db9078.svg";